import Swal from 'sweetalert2'

import { getSwal2IconHtmlFromIcon } from '@/utils/helpers/swal2-helper'

const originalSwalFire = Swal.fire
const newSwalFire = (...args) => {
  let options = {}

  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null) {
    options = { ...args[0] }
  } else if (args.length > 0) {
    options.title = args[0]
    if (args.length > 1) { options.html = args[1] }
    if (args.length > 2) { options.icon = args[2] }
  }

  // If the icon is provided as a string, convert it to HTML
  if (Object.hasOwn(options, 'icon')) {
    options.iconHtml = getSwal2IconHtmlFromIcon(options.icon)
    delete options.icon
  }

  return originalSwalFire.call(Swal, options)
}

Swal.fire = newSwalFire

export default ({ app }, inject) => {
  inject('Swal', Swal)
}
